export default __webpack_public_path__ + "static/media/IMG_9971.2fe25d37.jpeg";